import { z } from "zod";

export const imoOrNameSchema = (t: any, label: string, isDigitsOnly: boolean) =>
  z
    .string()
    .min(1, t("form-validation.required", { label }))
    .max(
      isDigitsOnly ? 8 : 50,
      isDigitsOnly
        ? t("form-validation.max-length-digits", {
            label: t("vessel-nomination.vessel-scan.imo-number"),
            maxDigits: 8,
          })
        : t("form-validation.max-length", {
            label: t("vessel-nomination.vessel-scan.vessel-name"),
            max: 50,
          }),
    );

export const vesselNominationScanSchema = (
  t: any,
  imoOrNameLabel: string,
  nominationTypeLabel: string,
  isDigitsOnly: boolean,
) =>
  z.object({
    imoOrName: imoOrNameSchema(t, imoOrNameLabel, isDigitsOnly),
    nominationType: z
      .string()
      .min(1, t("form-validation.required", { label: nominationTypeLabel })),
  });
